<template>
    <div class="row">
        <div class="col-md-offset-2 col-md-8">
            <div class="portlet light">
                <div class="portlet-title" style="display: flex; align-items: center;">
                    <div class="caption caption-md" style="width: 100%">
                        <i class="icon-bar-chart theme-font hide"></i>
                        <span class="sub-caption">Termos e Condições de uso</span>
                    </div>
                    <div style="flex-shrink: 0" v-if="$user">{{ $user.name }} ({{ $user.email }})</div>
                </div>
                <div class="portlet-body form" v-if="loading || !activeData">
                    <h4 style="text-align: center; padding: 30px">Carregando...</h4>
                </div>
                <div lass="portlet-body form" v-if="(!loading && !activeData) && !list.length">
                    <h4 style="text-align: center; padding: 30px">Não há termos disponíveis...</h4>
                </div>
                <div lass="portlet-body form" v-if="(!loading && activeData) && list.length">
                    <div class="alert alert-danger" v-if="pendingAgreements && pendingAgreements.length">
                        Você precisa aceitar os termos para utilizar o SCI Online, termos pendentes:
                        <b>{{ pendingAgreements }}</b>
                    </div>
                    <div class="tabbable-panel">
                        <div class="caption caption-md tabbable-line">
                            <i class="icon-bar-chart theme-font hide"></i>
                            <ul class="nav nav-tabs">
                                <li v-for="item in visibleList" :class="{active: item.alias === active}" v-tooltip
                                    :title="statusTitle(item)" @click="navigateTo(item)">
                                    <a class="sub-caption" href="javascript:;">
                                        {{ item.name }}
                                        <span v-if="item.agreeable && status">
                                            <i class="fa" :class="statusIconOf(item.id)"></i>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 terms-content">
                            <div class="content border-line">
                                <markdown :text="activeData.lastContract.contract"></markdown>
                            </div>

                            <div class="clearfix" v-if="activeStatus && (!activeStatus.isAccepted && activeData.agreeable)">
                                <div class="terms-footer remove-form-group-margin">
                                    <div class="terms-footer-item">
                                        <div style="margin-right: 5px">
                                            <form-new-check :compact="true"
                                                            label="Declaro que li e aceito os termos acima dispostos"
                                                            :model.sync="form.agreed"></form-new-check>
                                        </div>
                                        <div style="margin-right: 5px">
                                            <button class="btn orange"
                                                    :disabled="!form.agreed && activeData.required"
                                                    @click="accept()">CONTINUAR
                                            </button>
                                        </div>
                                    </div>
                                    <div class="terms-footer-item"
                                         v-if="activeData && !activeData.required">
                                        <div class="text-muted">
                                            Esse termo não é obrigatório, mas algumas funcionalidades podem ficar
                                            indisponíveis, caso não aceite.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const $ = require('jquery')
const R = require('ramda')
const Promise = require('bluebird')
const agreementClient = require('sci/helpers/agreement-client')
const Markdown = require('components/std/Markdown.vue')

const defaultForm = () => ({ agreed: false })

export default {
    name: 'index',
    components: { Markdown },
    route: {
        canReuse () {
            return false
        }
    },
    data () {
        return {
            skipped: [],
            loading: true,
            previous: null,
            required: [],
            active: null,
            list: null,
            status: null,
            pendingAgreements: false,
            form: defaultForm()
        }
    },
    ready () {
        this.active = this.$route.params.alias || null

        if (this.$route.query.previous) {
            this.previous = atob(this.$route.query.previous)
        }

        if (this.$route.query.required) {
            let required = []
            const parsedRequired = JSON.parse(atob(this.$route.query.required))

            if (Array.isArray(parsedRequired)) {
                required = parsedRequired
            }

            this.required = required
        }

        this.load().then(() => {
            if (this.$route.params.alias) {
                if (this.list.find(_ => _.alias === this.$route.params.alias)) {
                    return
                }
            }

            if (this.$route.query.ignoreStatus) {
                this.active = R.path([0, 'alias'], this.list)
            } else {
                this.active = this.next()
            }
        })
    },
    methods: {
        load () {
            this.loading = true
            return Promise.props({
                listRes: agreementClient.post(null, '', {
                    query: `
                            query {
                                list {
                                    id
                                    required
                                    agreeable
                                    alias
                                    name
                                    description
                                    lastContract {
                                        id
                                        draft
                                        excerpt
                                        contract
                                        createdAt
                                        updatedAt
                                    }
                                }
                            }
                        `
                }),
                statusRes: this.$user ? agreementClient.post(null, '', {
                    query: `
                            query($overrideRequired: [String!]) {
                                status(overrideRequired: $overrideRequired) {
                                    type {
                                        id
                                        required
                                        agreeable
                                        alias
                                        name
                                        description
                                    }
                                    isOk
                                    isAccepted
                                    lastAcceptedContract {
                                        id
                                    }
                                    lastAvailableContract {
                                        id
                                    }
                                }
                            }
                        `,
                    variables: {
                        overrideRequired: this.required
                    }
                }) : null
            }).then(({ listRes, statusRes }) => {
                this.list = R.sortBy(_ => _.id, listRes.data.list)

                if (statusRes) {
                    this.status = statusRes.data.status
                    this.pendingAgreements = this.status.filter(_ => !_.isOk).map(_ => _.type.name).join(', ')
                }

                this.loading = false

                return { list: this.list, pending: this.pendingAgreements, status: this.status }
            })
        },
        navigateTo (item) {
            this.form = defaultForm()
            this.active = item.alias
            $(document).scrollTo(0, 0)
            this.load()
            // this.$router.go({ name: 'terms-by-alias', params: { alias: item.alias }, query: this.$route.query })
        },
        next (fallbackToDefault = true) {
            if (this.status) {
                for (const current of this.status) {
                    if (!current.isOk && this.skipped.indexOf(current.type.alias) === -1) {
                        return current.type.alias
                    }
                }

                for (const current of this.status) {
                    if (!current.isAccepted && current.type.agreeable && this.skipped.indexOf(current.type.alias) === -1) {
                        return current.type.alias
                    }
                }
            }

            if (this.list.length && fallbackToDefault) {
                return this.list[0].alias
            }

            return null

            // if (this.list.length) {
            //     this.active = this.active ||
            //         R.pathOr(null, ['type', 'alias'], this.status.find(_ => !_.isAccepted)) ||
            //         this.list[0].alias
            // }
        },
        accept () {
            const data = this.activeData
            if (this.form.agreed) {
                if (data.lastContract) {
                    this.loading = true
                    agreementClient.post(null, '', {
                        query: `
                                mutation($ids: [Long!]!) {
                                    agree(ids: $ids)
                                }
                            `,
                        variables: {
                            ids: [data.lastContract.id]
                        }
                    }).then(() => {
                        this.form = defaultForm()
                        this.active = null
                        return this.load()
                    }).then((res) => {
                        const next = this.next(false)

                        if (next) {
                            this.active = next
                        } else {
                            if (this.previous) {
                                location.href = this.previous
                            } else {
                                location.href = '/'
                            }
                        }
                    })
                }
            } else {
                this.skipped.push(data.alias)

                const next = this.next(false)

                if (!next) {
                    if (this.previous) {
                        location.href = this.previous
                    } else {
                        location.href = '/'
                    }
                } else {
                    this.active = next
                    this.form = defaultForm()
                }
            }
        },
        statusTitle (item) {
            if (!item.agreeable) {
                return null
            }

            if (item.required) {
                return 'Obrigatório'
            }

            return 'Não é obrigatório, mas algumas funcionalidades podem ficar indisponíveis.'
        },
        statusIconOf (id) {
            if (!this.status) {
                return null
            }

            const status = this.status.find(_ => _.type.id === id)

            if (status) {
                if (status.isOk) {
                    if (status.isAccepted) {
                        return ['fa-check-circle', 'text-success']
                    } else {
                        return ['fa-times-circle', 'text-warning']
                    }
                } else {
                    return ['fa-times-circle', 'text-danger']
                }
            }
        }
    },
    computed: {
        activeData () {
            return this.list && this.list.find(_ => _.alias === this.active)
        },
        activeStatus () {
            return this.status && this.status.find(_ => _.type.alias === this.active)
        },
        visibleList () {
            return this.list.filter(_ => _.lastContract)
        }
    }
}
</script>

<style>
.terms-content h1 {
    font-size: 26px;
    font-weight: 600;
    margin: 10px 0 30px 0;
    color: #343434;
}

.terms-content h2 {
    font-size: 20px;
    font-weight: 600;
    margin: 35px 0 25px 0;
}

.terms-content p {
    font-size: 14px;
    color: #444;
    margin: 0 0 15px 0;
}

.terms-content ul li, .terms-content ol li {
    padding: 0 0 15px 0;
}

.terms-content .content {
    padding: 15px 0;
}

.terms-content code {
    box-shadow: none;
    border: none
}

.border-line {
    border-top: 1px solid #eee;
}

.terms-footer {
    padding-top: 15px;
    border-top: 1px solid #eee;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
}

.terms-footer-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

</style>


// WEBPACK FOOTER //
// Index.vue?56def0a5